import React from 'react';

import { Box, Typography } from '@mui/material';

export interface HeadingSectionProps {
  title: string;
  subtitle?: string | React.ReactElement;
  overTitle?: string | React.ReactElement;
}

export default function HeadingSection(props: HeadingSectionProps) {
  const { title, subtitle, overTitle } = props;

  return (
    <Box display="flex" flexDirection="column" alignItems="center" mb={3} mt={6} className="main-heading-section">
      {overTitle && (
        <Typography component="h2" variant="h4">
          {overTitle}
        </Typography>
      )}
      <Typography component="h1" variant="h1">
        {title}
      </Typography>
      {subtitle && (
        <Typography component="h2" variant="h4" sx={{ wordBreak: 'break-word' }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
